/**
 * Adapts server-side history (audit P-12) to the shapes the existing chat
 * components already render, WITHOUT touching the live useChatApp pipeline.
 *
 *  - Conversation list items -> ChatSidebar session shape { id, title, updatedAt }.
 *  - Conversation messages    -> ChatMessageList message shape { id, type, content,
 *    timestamp }. Only 'user'/'assistant' roles exist in the parsed data; text is
 *    carried as text and rendered through the existing markdown/text renderers
 *    (no raw HTML).
 */

function toMillis(value) {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string') {
    const parsed = Date.parse(value);
    return Number.isFinite(parsed) ? parsed : undefined;
  }
  return undefined;
}

function formatTimestamp(value) {
  const ms = toMillis(value);
  if (ms === undefined) return '';
  try {
    return new Date(ms).toLocaleString();
  } catch {
    return '';
  }
}

/** @param {Array<{conversationId:string,title:string,updatedAt:*}>} items */
export function historyListToSessions(items) {
  if (!Array.isArray(items)) return [];
  return items
    .filter((c) => c && typeof c.conversationId === 'string')
    .map((c) => ({
      id: c.conversationId,
      title: (typeof c.title === 'string' && c.title.trim()) ? c.title : 'Conversation',
      updatedAt: toMillis(c.updatedAt),
    }));
}

/** @param {Array<{role:'user'|'assistant',text:string,at:*}>} messages */
export function historyMessagesToThread(messages) {
  if (!Array.isArray(messages)) return [];
  return messages
    .filter((m) => m && (m.role === 'user' || m.role === 'assistant') && typeof m.text === 'string')
    .map((m, i) => ({
      id: `hist_${i}`,
      type: m.role,
      content: m.text,
      timestamp: formatTimestamp(m.at),
    }));
}
